import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import isEmail from "validator/lib/isEmail";
import {
  getSitesDropdownByManufacturerID,
  submitFormData,
} from "../../Utils/adminFunctions";
import { onlyNumber } from "../../Utils/commonFunctions";
import { Redirect } from 'react-router-dom';
import ScaleLoader from "react-spinners/ScaleLoader";

const AdminAddUser = () => {
  const { ip_address } = useContext(globalInfo);
  const { mID } = useParams();
  //for dropdowns//
  const [listSites, setListSites] = useState([]);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [contact, setContact] = useState("");
  const [userType, setUserType] = useState("");
  const [email, setEmail] = useState("");
  const [site, setSite] = useState("");
  const [status, setStatus] = useState("");
  const [desabledBtn, setDesabledBtn] = useState(false);

  const [errorFirstName, setErrorFirstName] = useState("");
  const [errorUserType, setErrorUserType] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorSite, setErrorSite] = useState("");
  const [errorStatus, setErrorStatus] = useState("");
  

  let handleSubmit = () => {
    setDesabledBtn(true);
    let errorRequiredFiled = 0;

    if (firstName === "") {
      setErrorFirstName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (userType === "") {
      setErrorUserType("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (email === "") {
      setErrorEmail("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (site === "") {
      setErrorSite("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (status === "") {
      setErrorStatus("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }

    if (isEmail(email) === false) {
      setErrorEmail("Incorrect email format");
      toast.warning("Incorrect email format ", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }

    const bodyFormData = new FormData();

    bodyFormData.append("manufacturer_id", mID);
    bodyFormData.append("first_name", firstName);
    bodyFormData.append("last_name", lastName);
    bodyFormData.append("contact", contact);
    bodyFormData.append("user_type", userType);
    bodyFormData.append("email", email);
    bodyFormData.append("site_id", site);
    bodyFormData.append("entered_by_ip", ip_address);
    bodyFormData.append("status", status);

    async function fetchAPI2() {
      const response = await submitFormData("addUser", bodyFormData);
      if (response.status === "success") {
        setFirstName("");
        setLastName("");
        setContact("");
        setUserType("");
        setEmail("");
        setSite("");
        setStatus("");
        toast.success(response.message, { autoClose: 1500 });
        window.location.href = `/AdminListUsers/${mID}`;
        // navigate to previous page after success
        setDesabledBtn(false);
      }
      if (response.status == "failure") {
        toast.warning(response.message, { autoClose: 1500 });
        setDesabledBtn(false);
      }
      if (response.status == "error") {
        toast.error(response.message, { autoClose: 1500 });
        setDesabledBtn(false);
      }
    }
    fetchAPI2();
  };

  useEffect(() => {
    async function fetchAPI1() {
      const response = await getSitesDropdownByManufacturerID(mID);
      if (response.status === "success") {
        setListSites(response.optionItems);
      } else {
        setListSites([]);
      }
    }
    fetchAPI1();
  }, [mID]);
  const phonNumberValidation = (number) => {
    const value = onlyNumber(number);
    setContact(value);
  };
  return (
    <div>
      {desabledBtn&&(
        <div style={{
          zIndex:100000,
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          position: "fixed",
         inset:0,
          backgroundColor: 'rgba(86, 86, 86, 0.8)'
        }}>
        <ScaleLoader
  color="#F58634"
  height={100}
  margin={5}
  radius={8}
  width={20}
/>
        </div>
      )}
      <div className="wrapper">
        <div>
          
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to={"/AdminListUsers/" + mID}
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                First Name<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorFirstName ? " is-invalid" : "")
                                }
                                value={firstName}
                                onChange={(e) => {
                                  setFirstName(e.target.value);
                                  setErrorFirstName("");
                                }}
                                placeholder="First Name"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Last Name
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={lastName}
                                placeholder="Last Name"
                                onChange={(e) => {
                                  setLastName(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Contact No.
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={contact}
                                placeholder="Contact No."
                                onChange={(e) => {
                                  phonNumberValidation(e.target.value);
                                }}
                                maxLength={12}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                User Type<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control custom-select" +
                                  (errorUserType ? " is-invalid" : "")
                                }
                                onChange={(e) => {
                                  setUserType(e.target.value);
                                  setErrorUserType("");
                                }}
                                value={userType}
                              >
                                <option value="">Select</option>
                                <option value="3">Primary User</option>
                                <option value="2">Secondary User</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Email<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorEmail ? " is-invalid" : "")
                                }
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                  setErrorEmail("");
                                }}
                                value={email}
                                placeholder="Email"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Site<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control custom-select" +
                                  (errorSite ? " is-invalid" : "")
                                }
                                onChange={(e) => {
                                  setSite(e.target.value);
                                  setErrorSite("");
                                }}
                                value={site}
                              >
                                <option value="">Select</option>
                                {listSites}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Status<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control custom-select" +
                                  (errorStatus ? " is-invalid" : "")
                                }
                                onChange={(e) => {
                                  setStatus(e.target.value);
                                  setErrorStatus("");
                                }}
                                value={status}
                              >
                                <option value="">Select</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <button
                              type="button"
                              className="btn btn-sm custom-btn-primary pull-right"
                              onClick={handleSubmit}
                              disabled={desabledBtn}
                            >
                              {desabledBtn?"Loading...":"Submit"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAddUser;
